const MAX_ROUTE_HISTORY = 50
const routeHistory = []

function isTerminalRoute (route = {}) {
  return Array.isArray(route.matched) && route.matched.some(record => record.meta && record.meta.terminalShell)
}

/**
 * 记录每一次真正完成的终端页面跳转。
 * 与浏览器 history 不同，这里也会保留通过 router.replace 打开的页面。
 */
export function recordTerminalRoute (route = {}) {
  if (route.path === '/login') {
    routeHistory.splice(0)
    return
  }
  if (!isTerminalRoute(route) || !route.fullPath) return
  if (routeHistory[routeHistory.length - 1] === route.fullPath) return

  routeHistory.push(route.fullPath)
  if (routeHistory.length > MAX_ROUTE_HISTORY) routeHistory.shift()
}

/**
 * 取出当前页面的站内上一页，同时让历史栈回退一格。
 */
export function takePreviousTerminalRoute (currentFullPath = '') {
  if (currentFullPath && routeHistory[routeHistory.length - 1] !== currentFullPath) {
    routeHistory.push(currentFullPath)
  }
  if (routeHistory.length < 2) return ''

  routeHistory.pop()
  return routeHistory[routeHistory.length - 1] || ''
}

/** 导航未完成时恢复刚才弹出的当前页。 */
export function restoreTerminalRoute (fullPath = '') {
  if (!fullPath || routeHistory[routeHistory.length - 1] === fullPath) return
  routeHistory.push(fullPath)
}
